import React from "react"
import { useUserActionAuditTrailContext } from "contexts/UserActionAuditTrailContext"
import { TertiaryButton } from "shared/buttons"

const LoadMoreButton = () => {
  const { allAuditsLoaded, fetchAudits } = useUserActionAuditTrailContext()

  if (allAuditsLoaded) return null

  return (
    <TertiaryButton className="block mx-auto" onClick={fetchAudits} text="Load more" />
  )
}

export default LoadMoreButton
